import Temp from "@/courier/Temp";

export default class ShopeeXpress extends Temp {
  static CODE = "SPXP";

  constructor() {
    super(ShopeeXpress.CODE);
  }

  static NAMEZONE = {
    BKK: 1,
    UPC: 2,
    
  };
  
  static NAMETYPE = {
    BKK_TO_BKK: 1,
    BKK_TO_UPC: 2,
    UPC_TO_BKK: 3,
    UPC_TO_UPC: 4
  };

  getZone(item, courier) {
    let type, to, from;
    let cross_price = 0;
    let remote_area = 0;

    let prefixToPostCode = item.toPostcode.toString().substring(0, 2);
    let prefixFromPostCode = item.fromPostcode.toString().substring(0, 2);
    // BKK else UPC
    from = super.checkZone(prefixFromPostCode)===1?1:2;
    to = super.checkZone(prefixToPostCode)===1?1:2;
    
    remote_area = super.checkRemoteArea(Number(item.toPostcode));
    
    if (new Date(courier.effective_date) >= new Date("2022-11-01 00:00:00")) {
      if (to == ShopeeXpress.NAMEZONE.BKK && from == ShopeeXpress.NAMEZONE.BKK) {
        type = ShopeeXpress.NAMETYPE.BKK_TO_BKK;
      } else if (from == ShopeeXpress.NAMEZONE.BKK && to == ShopeeXpress.NAMEZONE.UPC) {
        type = ShopeeXpress.NAMETYPE.BKK_TO_UPC;
      } else if (from == ShopeeXpress.NAMEZONE.UPC && to == ShopeeXpress.NAMEZONE.BKK) {
        type = ShopeeXpress.NAMETYPE.UPC_TO_BKK;
      } else if (from == ShopeeXpress.NAMEZONE.UPC && to == ShopeeXpress.NAMEZONE.UPC) {
        type = ShopeeXpress.NAMETYPE.UPC_TO_UPC;
      }
    } else {
      if (to == ShopeeXpress.NAMEZONE.BKK) {
        type = ShopeeXpress.NAMEZONE.BKK;
      } else {
        type = ShopeeXpress.NAMEZONE.UPC;
      }
    }
    return {
      rate_type: type,
      rate_remote_area: remote_area,
      cross_price: cross_price,
    };
  }

  checkWeight(courierRates, item, validate) {
    item.index = courierRates.findIndex((rate) => {
      return item.weight >= rate.min && item.weight <= rate.max;
    });

    return super.checkRules(item, validate);
  }
  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }

  async checkRemoteAreaByCorrectorDest(addressRemote) {
    return new Promise((resolve) => {
      super.getArea([addressRemote], ["SPXP"]).then((res) => {
        let returnRate = {
          isRemote: res.data[ShopeeXpress.CODE].is_remote ? 50:0,
          isTravelArea: 0,
          isIsland: 0
        };
        resolve(returnRate);
      })
    });
  }
}
